export const isScenarioInProgress = percentageCompleted =>
  percentageCompleted !== undefined && Number(percentageCompleted) < 100;
